// @flow

import type {MapState} from '../types'

export const initialState: MapState = {
  isReady: false,
  apiIndex: null,
  serviceProviders: [],
  googleMap: null,
  cities: [],
  districts: [],
  selectedCity: null,
}
